import React, { forwardRef, useEffect, useState } from 'react';
import {
  TextField,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
  Typography,
  IconButton
} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { getMaxEndDate } from '../../../utils/Utilities';

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */

export default function ExportDataModal({
  openDateRangeModal,
  handleClose,
  actionData,
  onAction
}) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateError, setDateError] = useState('');

  useEffect(() => {
    if (openDateRangeModal) {
      setStartDate(null);
      setEndDate(null);
      setDateError('');
    }
  }, [openDateRangeModal]);

  const handleStartDateChange = (date) => {
    setDateError('');
    setStartDate(date);

    if (date && endDate) {
      const maxE = getMaxEndDate(date);

      if (endDate.startOf('day').isAfter(maxE, 'day')) {
        setEndDate(maxE);
      }
    }
  };

  const handleEndDateChange = (date) => {
    setDateError('');

    if (date && startDate) {
      const maxE = getMaxEndDate(startDate);

      if (date.startOf('day').isAfter(maxE, 'day')) {
        setEndDate(maxE);
        return;
      }
    }

    setEndDate(date);
  };

  const handleExport = () => {
    if (!startDate || !endDate) {
      setDateError('Please select both start and end dates.');
      return;
    }

    const startD = startDate.startOf('day');
    const endD = endDate.startOf('day');

    if (endD.isBefore(startD, 'day')) {
      setDateError('End date must be on or after the start date.');
      return;
    }

    const maxE = getMaxEndDate(startDate);

    if (endD.isAfter(maxE, 'day')) {
      setDateError('Date range cannot exceed one month.');
      return;
    }

    setDateError('');

    onAction({
      startDate,
      endDate,
      actionData
    });

    handleClose();
  };

  const endMaxDate = startDate ? getMaxEndDate(startDate) : dayjs();

  return (
    <Dialog
      open={openDateRangeModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="date-range-dialog-slide-description"
      data-testid="export-data-modal"
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          fontFamily: 'Montserrat',
          fontWeight: 600
        }}
      >
        Export Data
        <IconButton edge="end" onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="date-range-dialog-slide-description" component="div">
          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            Maximum date range is one month.
          </Typography>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={3} direction={{ xs: 'column', sm: 'row', md: 'row' }}>
              
              <Grid size={{ xs: 6 }}>
                <DatePicker
                  openTo="day"
                  views={['year', 'month', 'day']}
                  value={startDate}
                  label="Start Date"
                  onChange={handleStartDateChange}
                  maxDate={dayjs()}
                  format="DD-MM-YYYY"
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      readOnly: false,
                      inputProps: { 'data-testid': 'start-date', readOnly: false }
                    }
                  }}
                />
              </Grid>

              <Grid size={{ xs: 6 }}>
                <DatePicker
                  openTo="day"
                  views={['year', 'month', 'day']}
                  value={endDate}
                  maxDate={endMaxDate}
                  minDate={startDate || undefined}
                  label="End Date"
                  format="DD-MM-YYYY"
                  onChange={handleEndDateChange}
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: false,
                      inputProps: { 'data-testid': 'end-date', readOnly: false }
                    }
                  }}
                />
              </Grid>

            </Grid>
          </LocalizationProvider>

          {dateError && (
            <Typography variant="caption" color="error" sx={{ display: 'block', mt: 2 }}>
              {dateError}
            </Typography>
          )}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          data-testid="export-ok-button"
          variant="contained"
          onClick={handleExport}
          sx={{ mr: 2, mb: 2, borderRadius: 2 }}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
}